var map = {
	"./ComTechGold/comtech_1.png": 6997,
	"./ComTechGold/comtech_2.webp": 3476,
	"./ComTechGold/comtech_3.webp": 7511,
	"./ComTechGold/comtech_4.webp": 7978,
	"./ComTechGold/comtech_5.webp": 1333,
	"./ComTechGold/comtech_6.png": 490,
	"./ComTechGold/comtech_7.png": 8067,
	"./ComTechGold/comtech_8.png": 404,
	"./Niftycart.jpg": 5814,
	"./Tabletop.jpg": 1393,
	"./Vidash_apna.png": 4283,
	"./alex.jpg": 760,
	"./atx.jpg": 451,
	"./bright_view_care.png": 6776,
	"./bruvi.png": 8832,
	"./bruvi_cloud.png": 7854,
	"./bruvi_cloud/Screenshot 2026-01-04 194504.png": 1269,
	"./bruvi_cloud/Screenshot 2026-01-04 194526.png": 1889,
	"./bruvi_cloud/Screenshot 2026-01-04 194546.png": 8819,
	"./bruvi_cloud/Screenshot 2026-01-04 194600.png": 7826,
	"./bruvi_cloud/Screenshot 2026-01-04 194613.png": 8534,
	"./bruvi_cloud/Screenshot 2026-01-04 194627.png": 1799,
	"./bruvi_cloud/Screenshot 2026-01-04 194642.png": 1404,
	"./bruvi_cloud/Screenshot 2026-01-04 194657.png": 5142,
	"./bruvi_cloud/Screenshot 2026-01-04 194742.png": 1277,
	"./budget_fiscal.png": 5210,
	"./budget_fiscal_overview.png": 4190,
	"./cashflow.png": 3937,
	"./chain_alytics.png": 6103,
	"./collegerasta.png": 5726,
	"./comtech_gold.png": 3068,
	"./doctyme.jpg": 4063,
	"./evebtalog.jpg": 8583,
	"./fleet_management.png": 6874,
	"./hrm.png": 1273,
	"./hyundai_crm.png": 917,
	"./hyundaicrm/Screenshot 2026-01-04 202408.png": 5158,
	"./hyundaicrm/Screenshot 2026-01-04 202439.png": 2430,
	"./hyundaicrm/Screenshot 2026-01-04 202459.png": 2732,
	"./hyundaicrm/Screenshot 2026-01-04 202530.png": 1550,
	"./hyundaicrm/Screenshot 2026-01-04 202605.png": 1745,
	"./hyundaicrm/Screenshot 2026-01-04 202634.png": 2853,
	"./hyundaicrm/Screenshot 2026-01-04 202659.png": 8650,
	"./hyundaicrm/Screenshot 2026-01-04 202720.png": 691,
	"./hyundaicrm/Screenshot 2026-01-04 202749.png": 4088,
	"./lab.png": 5631,
	"./laundry_management.png": 291,
	"./memo.jpg": 6326,
	"./mersion.png": 3549,
	"./metasociety.png": 6341,
	"./molex.png": 9825,
	"./momy_kidz.png": 6345,
	"./nexus_crm.png": 8838,
	"./order_dashboard.png": 9687,
	"./parsil.jpg": 3967,
	"./petskey.jpg": 5049,
	"./petskey/image (1).jpg": 9449,
	"./petskey/image (2).jpg": 944,
	"./petskey/image (3).jpg": 3907,
	"./petskey/image (4).jpg": 1970,
	"./petskey/image (5).jpg": 7501,
	"./petskey/image (6).jpg": 6612,
	"./petskey/image (7).jpg": 2807,
	"./portfolio/1695974180786_WhatsApp Image 2023-09-26 at 4.19.30 PM.jpeg": 3322,
	"./portfolio/1695982863770_WhatsApp Image 2023-09-26 at 4.15.21 PM (1).jpeg": 14,
	"./portfolio/1695982901179_WhatsApp Image 2023-09-26 at 4.15.21 PM (1).jpeg": 6414,
	"./portfolio/1695982946206_WhatsApp Image 2023-09-26 at 4.15.21 PM (1).jpeg": 1062,
	"./portfolio/1695983827937_atx.jpg": 1528,
	"./portfolio/1695983948870_evebtalog.jpg": 3902,
	"./portfolio/1695984020721_lab.png": 4165,
	"./portfolio/1695984121673_memo.jpg": 4304,
	"./portfolio/1695984206409_mersion.png": 9348,
	"./portfolio/1695984281362_parsil.jpg": 8753,
	"./portfolio/1695984352671_hrm.png": 4141,
	"./portfolio/1695984442612_collegerasta.png": 757,
	"./portfolio/1695984498235_alex.jpg": 1485,
	"./portfolio/1695984583800_doctyme.jpg": 1365,
	"./portfolio/1695984633244_Niftycart.jpg": 9068,
	"./portfolio/1695984672972_sevenwest.jpg": 349,
	"./portfolio/1695984717175_Tabletop.jpg": 6165,
	"./portfolio/1695984765448_yamuna.png": 2911,
	"./portfolio/1696435480768_Untitled.jpg": 1872,
	"./portfolio/1696487539421_Untitled.jpg": 1290,
	"./portfolio/1696487697508_Untitled1.jpg": 9506,
	"./portfolio/1696846292033_logo 1.jpeg": 9292,
	"./portfolio/1698747472226_download.jpg": 8207,
	"./portfolio/1698752551763_download.png": 289,
	"./portfolio/1699334723742_download.jpg": 9800,
	"./portfolio/1699334858808_download.jpg": 8762,
	"./portfolio/1699335808731_download.jpg": 1967,
	"./portfolio/1699335865261_download.png": 3614,
	"./portfolio/1699349895465_Screenshot 2023-10-16 190548.png": 4670,
	"./portfolio/1699350529695_Screenshot 2023-09-28 134217.png": 2235,
	"./portfolio/1699351160002_Screenshot 2023-10-16 190157.png": 9377,
	"./portfolio/1699352175363_Screenshot 2023-10-16 190157.png": 4942,
	"./portfolio/1699352244817_Screenshot 2023-09-28 134217.png": 7021,
	"./portfolio/1699353186039_Screenshot 2023-09-28 134227.png": 1790,
	"./portfolio/1699353496582_Screenshot 2023-10-16 190157.png": 9526,
	"./portfolio/1699356046123_Screenshot 2023-09-28 134217.png": 7853,
	"./portfolio/1699356428808_Screenshot 2023-09-28 134227.png": 5420,
	"./portfolio/1699356446675_Screenshot 2023-09-28 134217.png": 8484,
	"./portfolio/1699420102304_Screenshot 2023-09-28 134217.png": 4969,
	"./portfolio/1699420517819_Screenshot 2023-09-28 134217.png": 7640,
	"./portfolio/1699520332003_Screenshot 2023-09-28 134217.png": 965,
	"./portfolio/1701929541220_icici-bank-aeps.jpg": 1243,
	"./portfolio/1701929840873_Screenshot 2023-11-09 150719.png": 9856,
	"./portfolio/1701929840873_Screenshot 2023-11-30 121744.png": 5454,
	"./portfolio/1701930003160_Screenshot 2023-10-16 190157.png": 9355,
	"./portfolio/1701930003161_Screenshot 2023-10-16 190216.png": 5918,
	"./portfolio/1701930003163_Screenshot 2023-10-16 190239.png": 7897,
	"./portfolio/1701931777814_icici-bank-aeps.jpg": 804,
	"./portfolio/1701947987358_Screenshot 2023-09-28 134227.png": 6910,
	"./portfolio/1701947987359_Screenshot 2023-11-09 150719.png": 9959,
	"./portfolio/1701948138625_Screenshot 2023-11-30 121744.png": 1838,
	"./portfolio/1701948138627_Screenshot 2023-12-04 191553.png": 5461,
	"./portfolio/1701949497070_Screenshot 2023-11-30 121744.png": 9153,
	"./portfolio/1701949497071_Screenshot 2023-12-04 191553.png": 3715,
	"./portfolio/1701949497072_Screenshot 2023-10-16 190216.png": 3154,
	"./portfolio/1702013474652_15 August 2023 - 1.jpeg": 2515,
	"./portfolio/1702451038904_Screenshot 2023-11-30 121744.png": 9413,
	"./portfolio/1702451258925_Screenshot 2023-11-09 150719.png": 2134,
	"./portfolio/1702451471377_Screenshot 2023-11-09 150719.png": 4770,
	"./portfolio/1702451917887_Screenshot 2023-11-30 121744.png": 7583,
	"./portfolio/1706093709408_pencil-63-512.png": 4080,
	"./portfolio/1706100488987_image (2).png": 2771,
	"./portfolio/1706101415510_Atx-3.png": 5525,
	"./portfolio/1706102311265_Atx-3.png": 1712,
	"./portfolio/1706507293304_Atx-3.png": 2902,
	"./portfolio/1706507535448_Molex-2.png": 5795,
	"./portfolio/1706507827069_Propero-LoginPage.png": 8914,
	"./portfolio/1706507954525_Railway-LoginPage.png": 9118,
	"./portfolio/1706508035301_RentPlant-LoginPage.png": 8426,
	"./portfolio/1706508591168_Exult-2.png": 234,
	"./portfolio/1706508736997_Chess-MainPage.png": 489,
	"./portfolio/1706508860872_Security-LoginPage.png": 4789,
	"./portfolio/1706509095019_Silo-Dashboard.png": 2910,
	"./portfolio/1706509223170_TheLab-2.png": 5106,
	"./portfolio/1706509294039_TigeBoat-3.png": 9040,
	"./portfolio/1706509403984_VideshApna-LoginPage.png": 3956,
	"./portfolio/1706509750534_ViceA-Dashboard.png": 3031,
	"./portfolio/1706509917984_WiseCaller-LoginPage.png": 2632,
	"./portfolio/1706510047435_Curific-LoginPage.png": 7681,
	"./portfolio/1713345801510_newDb - public.png": 2325,
	"./portfolio/1713353148628_image.png": 6405,
	"./portfolio/1713353152143_image.png": 3940,
	"./portfolio/1713355597992_Statment of NPS Credit 2024-04-16 at 2.45.27 PM.jpeg": 1527,
	"./portfolio/1713357932266_Secretary Role Dashboard.png": 3111,
	"./portfolio/1713358338853_Member Role Dashboard.png": 7998,
	"./portfolio/1713415716530_1695983827937_atx.jpg": 9881,
	"./portfolio/1713415792527_1695983827937_atx.jpg": 4297,
	"./portfolio/1713415826073_image.png": 9341,
	"./portfolio/1713415883376_1695983827937_atx.jpg": 8234,
	"./portfolio/1713433208019_360_F_229758328_7x8jwCwjtBMmC6rgFzLFhZoEpLobB6L8.jpg": 835,
	"./portfolio/1713434454817_360_F_229758328_7x8jwCwjtBMmC6rgFzLFhZoEpLobB6L8.jpg": 3001,
	"./portfolio/1713440634990_image001.jpg": 5113,
	"./portfolio/1713440674694_image001.jpg": 2556,
	"./portfolio/1713441021593_image001.jpg": 2531,
	"./portfolio/1713441332238_image001.jpg": 994,
	"./portfolio/1713442821698_Rent_plant.png": 7389,
	"./portfolio/1713442844186_Rent_plant.png": 6624,
	"./portfolio/1713442881417_Secure_Gates.png": 6201,
	"./portfolio/1713442907167_comtec_gold.png": 4032,
	"./portfolio/1713442943104_Auto_Hauler.png": 3292,
	"./portfolio/1713442961908_Knowland.png": 1933,
	"./portfolio/1713442981033_Emo.png": 5663,
	"./portfolio/1713443030238_Silo.png": 9542,
	"./portfolio/1713443101007_Vice_armony.png": 2354,
	"./portfolio/1713443118028_Artify_Print.png": 3558,
	"./portfolio/1713443148364_Vice_armony.png": 7575,
	"./portfolio/1713443233104_Secure_Gates.png": 4600,
	"./portfolio/1713443281249_Curific.jpg": 8476,
	"./portfolio/1713443378350_Curific.jpg": 828,
	"./portfolio/1713870648728_6339707.jpg": 7795,
	"./portfolio/1713882450505_Triko.png": 1604,
	"./portfolio/1714112941702_image001.jpg": 8344,
	"./portfolio/1714112957386_woomake backend.png": 438,
	"./portfolio/1714115042659_6339707.jpg": 8893,
	"./portfolio/1714117528977_6339707.jpg": 275,
	"./portfolio/1714117563792_Media (1).jpg": 1846,
	"./portfolio/1714118104004_Media (2).jpg": 6741,
	"./portfolio/1714393372984_1.jpg": 8372,
	"./portfolio/1714393618270_eventlog.jpg": 8216,
	"./portfolio/1714393640044_memo maker.jpg": 2389,
	"./portfolio/1714393662790_parsial lab.jpg": 4869,
	"./portfolio/1714393683213_hrm.jpg": 3350,
	"./portfolio/1714393702764_college rasta.jpg": 9702,
	"./portfolio/1714393729145_nifty cart.jpg": 5674,
	"./portfolio/1714393817062_table top.jpg": 1513,
	"./portfolio/1714393839086_yamuna hub.jpg": 7750,
	"./portfolio/1714393870421_atx surf.jpg": 3793,
	"./portfolio/1714393896298_lab.jpg": 5963,
	"./portfolio/1714393926172_mersino.jpg": 6115,
	"./portfolio/1714547194008_curific.png": 9940,
	"./portfolio/1714548052710_enrolme.jpg": 1055,
	"./portfolio/1714548102688_fightingchess.jpg": 8871,
	"./portfolio/1714548125635_exult.jpg": 6118,
	"./portfolio/1714548147012_prophero.jpg": 2598,
	"./portfolio/1714713486601_petskey.png": 7510,
	"./portfolio/1714713737933_aptiv - Copy.png": 4206,
	"./portfolio/1716972996125_Memo Maker.png": 6815,
	"./portfolio/1716974232946_Nifty Cart.png": 2289,
	"./portfolio/1716975123343_EventaLog.png": 7441,
	"./portfolio/1716975150893_Memo Maker.png": 1154,
	"./portfolio/1716975268611_Parishil Lab.png": 92,
	"./portfolio/1716975296332_Centillion HRM.png": 7401,
	"./portfolio/1716975319272_College Rasta.png": 4602,
	"./portfolio/1716975344148_Nifty Cart.png": 3058,
	"./portfolio/1716975384545_Sevenwest Fitness.png": 6687,
	"./portfolio/1716975406282_Table Top.png": 2291,
	"./portfolio/1716975460966_Yamuna Hub.png": 1493,
	"./portfolio/1716975612511_ATX Boat.png": 1017,
	"./portfolio/1716975633908_Molex.png": 8398,
	"./portfolio/1716975670644_Prop Hero.png": 9682,
	"./portfolio/1716975844663_Exhault It.png": 3877,
	"./portfolio/1716975875102_Fighting Chess.png": 4089,
	"./portfolio/1716975964622_LAB.png": 1978,
	"./portfolio/1716976012936_Curific.png": 4809,
	"./portfolio/1716976068860_Videsh Apna.png": 6502,
	"./portfolio/1716976134678_Vice Armory.png": 8339,
	"./portfolio/1716976169459_Pets Key.png": 796,
	"./portfolio/1716976201664_Mersino.png": 1711,
	"./portfolio/1716976224146_Emo-Enrollment.png": 1900,
	"./portfolio/1716976312208_Aptiv.png": 8867,
	"./portfolio/1716976647344_Artify Print.png": 845,
	"./portfolio/Curific.jpg": 3932,
	"./portfolio/Vidash_apna.png": 8217,
	"./portfolio/comtec_gold.png": 8817,
	"./prophero.png": 3483,
	"./prophero_app/contact.webp": 9174,
	"./prophero_app/dashboard (2).webp": 4691,
	"./prophero_app/details.webp": 2280,
	"./prophero_app/lead.webp": 9272,
	"./prophero_app/login.webp": 4343,
	"./prophero_app/profile.webp": 3551,
	"./prophero_app/viewing.webp": 4825,
	"./sevenwest.jpg": 2112,
	"./shipment_details.png": 3789,
	"./truvo_invoice.png": 4984,
	"./white_clerk.png": 3843,
	"./wisecaller.png": 3298,
	"./wisecaller/image (1).jpg": 5109,
	"./wisecaller/image (10).png": 2191,
	"./wisecaller/image (11).png": 2936,
	"./wisecaller/image (12).png": 3093,
	"./wisecaller/image (13).png": 5742,
	"./wisecaller/image (14).png": 8192,
	"./wisecaller/image (15).png": 9519,
	"./wisecaller/image (16).png": 889,
	"./wisecaller/image (17).png": 850,
	"./wisecaller/image (18).png": 1719,
	"./wisecaller/image (2).jpg": 3772,
	"./wisecaller/image (3).jpg": 3823,
	"./wisecaller/image (4).png": 8290,
	"./wisecaller/image (5).png": 2873,
	"./wisecaller/image (6).png": 2956,
	"./wisecaller/image (7).png": 4195,
	"./wisecaller/image (8).png": 3606,
	"./wisecaller/image (9).png": 9789,
	"./yamuna.png": 1855
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 815;